export interface FAQItem {
  question: string;
  answer: string;
}

export const faqList: FAQItem[] = [
  {
    question: '黄油游戏下载是否真的免费？',
    answer: '是的，本站推荐的所有游戏下载渠道均为官方正版或合法授权的免费资源。部分游戏可能提供免费试玩版本或限时免费活动，我们会在每篇教程中明确标注游戏的收费情况。请放心，本站不会推荐任何需要付费才能下载的非官方渠道。',
  },
  {
    question: '如何确保下载的游戏文件安全无毒？',
    answer: '我们建议从以下三个方面确保下载安全：第一，优先选择游戏官方网站或知名平台（如Steam、Epic等）下载；第二，下载后使用正规杀毒软件扫描文件；第三，核对文件MD5/SHA校验值是否与官方公布的一致。本站所有教程都会标注推荐的安全下载渠道。',
  },
  {
    question: '黄油游戏支持哪些操作系统？',
    answer: '黄油游戏主要支持Windows 10/11操作系统，部分游戏也提供macOS和Linux版本。在每篇游戏下载教程中，我们会详细列出该游戏支持的操作系统版本和最低配置要求。对于不支持的操作系统，我们也会提供虚拟机或兼容层等替代方案。',
  },
  {
    question: '下载的游戏无法运行怎么办？',
    answer: '游戏无法运行通常有以下几种原因：缺少必要的运行库（如DirectX、VC++运行库等）、显卡驱动版本过旧、系统兼容性问题、或文件损坏不完整。我们建议按以下步骤排查：1）安装最新版DirectX和VC++运行库；2）更新显卡驱动；3）以管理员身份运行游戏；4）尝试验证游戏文件完整性。',
  },
  {
    question: '黄油游戏下载需要注册账号吗？',
    answer: '这取决于下载渠道。如果通过Steam、Epic等平台下载，需要注册对应平台的账号。如果通过游戏官方网站直接下载，通常不需要注册。本站教程会详细说明每个渠道的下载流程和注册要求，方便你选择最适合的方式。',
  },
  {
    question: '下载速度慢如何优化？',
    answer: '下载速度慢可以尝试以下方法：1）更换下载节点/服务器（Steam等平台支持切换下载区域）；2）使用有线网络连接代替WiFi；3）避开网络高峰时段下载；4）检查后台是否有其他占用带宽的程序。此外，部分平台支持P2P下载加速功能，开启后可以显著提升下载速度。',
  },
  {
    question: '可以将已下载的游戏迁移到其他电脑吗？',
    answer: '可以的。大多数游戏支持通过以下方式迁移：1）使用Steam等平台的备份/恢复功能；2）直接复制游戏文件夹到新电脑的相同路径；3）使用外部硬盘作为游戏库存储设备。具体操作方法请参考本站的游戏迁移教程文章。',
  },
  {
    question: '黄油游戏的更新补丁如何下载安装？',
    answer: '通过官方平台下载的游戏会自动接收更新推送，无需手动操作。独立下载的游戏则需要关注官方发布的更新公告，手动下载并安装补丁。本站会及时更新各游戏的最新版本信息和更新教程，帮助你保持游戏处于最新状态。',
  },
];

export const aboutFAQList: FAQItem[] = [
  {
    question: '黄油游戏下载是什么？',
    answer: '黄油游戏下载是一个专注于为中文玩家提供安全、可靠游戏下载指南的平台。我们汇聚了丰富的游戏下载教程、安装方法、安全渠道推荐和常见问题解答，致力于帮助每一位玩家轻松完成游戏下载，畅享优质游戏体验。',
  },
  {
    question: '黄油游戏下载的内容是否可信？',
    answer: '我们始终坚持严格的审核标准，所有推荐内容均经过团队实际验证。每个下载渠道和安装教程都确保安全可靠。我们与多家知名游戏平台保持合作关系，确保信息的准确性和时效性。',
  },
  {
    question: '如何联系黄油游戏下载团队？',
    answer: '你可以通过以下方式联系我们：发送邮件至 contact@huangyougame.com，或访问我们的社交媒体账号获取最新资讯。我们会在24小时内回复你的咨询。对于商务合作、内容投稿等需求，也欢迎通过邮件与我们联系。',
  },
];